<div class="panel panel-form" [ngClass]="{ open: open }">
  <lib-form-header [open]="open" [header]="header" [required]="required" (openChange)="open = $event"></lib-form-header>
  @if (open && form) {
    <div class="panel-content">
      <form [formGroup]="form">
        <!-- <div class="row"> -->
        <!-- <div class="col-12"> -->
        <div class="row">
          @for (key of order; track key; let i = $index) {
            <!-- <ng-container *ngIf="i<3"> -->
            <div class="col-12 col-sm-6">
              <ng-container *ngTemplateOutlet="formField; context: { key: key }"></ng-container>
            </div>
            <!-- </ng-container> -->
          }
        </div>
        <!-- </div> -->
        <!-- <div class="col-12 col-sm-6">
    <div class="row">
      <ng-container *ngFor="let key of order; let i=index">
        <ng-container *ngIf="i>2">
          <ng-container *ngTemplateOutlet="formField; context: {key: key}"></ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div> -->
        <!-- </div> -->
        <ng-template #formField let-key="key">
          <div class="form-field-container">
            <div class="form-field-label" [ngClass]="{ required: isFormControlRequired(getFormControl(key)) }">
              {{ 'form.field.' + key | transloco }}
            </div>
            <mat-form-field class="form-field" [floatLabel]="'auto'">
              <input
                matInput
                [formControlName]="key"
                [placeholder]="key !== 'phone' && key !== 'email' ? ('form.placeholder.url' | transloco) : ''"
                [required]="isFormControlRequired(getFormControl(key))"
              />
              @if (getFormControl(key).invalid) {
                <mat-error>
                  @if (getFormControl(key).errors.required) {
                    {{ 'form.error.required' | transloco }}
                  }
                  @if (getFormControl(key).errors.email) {
                    {{ 'form.error.invalid_email' | transloco }}
                  }
                  @if (getFormControl(key).errors.pattern) {
                    {{ 'form.error.invalid_link' | transloco }}
                  }
                </mat-error>
              }
            </mat-form-field>
          </div>
        </ng-template>
      </form>
    </div>
  }
</div>
